import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const ContainerApi = createAsyncThunk(
    'ContainerApi',
    async () => {
        let url = baseUrl+'getcontainer';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
       
        if(response?.data?.status === "succes"){
         
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const AirportMaster = createAsyncThunk(
    'AirportMaster',
    async () => {
        let url = baseUrl+'getairportmaster';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
      
     
        if(response.status == "success"){
        
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const CommudityMaster = createAsyncThunk(
    'CommudityMaster',
    async () => {
        let url = baseUrl+'getcommoditymaster';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
      
       
        if(response.data.status === "succes"){
       
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const IMOMaster = createAsyncThunk(
    'IMOMaster',
    async () => {
        let url = baseUrl+'getIMOmaster';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))

       
        if(response.data.status === "succes"){
        
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );
 

  export const UNMaster = createAsyncThunk(
    'UNMaster',
    async () => {
        let url = baseUrl+'getUNmaster';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
      
       
        if(response.data.status === "succes"){
        
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const companyList = createAsyncThunk(
    'companyList',
    async () => {
        let url = baseUrl+'getcompanyList';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
      
        
        if(response.data.status === "succes"){
        
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const services = createAsyncThunk(
    'services',
    async () => {
        let url = baseUrl+'getservices';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
       
      
        if(response.data.status === "success"){
     
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const Insertservices = createAsyncThunk(
    'Insertservices',
    async (data) => {
        let url = baseUrl+'Insertservices';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
       console.log(response,"response")
      
        if(response.status === "success"){
     
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );
  


  

  

